import { loadStripe } from '@stripe/stripe-js/pure'
import type { Stripe } from '@stripe/stripe-js'

let cached: { key: string; loading: Promise<Stripe | null> } | null = null

/** The `/pure` entry defers the Stripe.js script until a form opens, so flag-off pages never load it. */
export const getStripe = (publishableKey: string): Promise<Stripe | null> => {
  if (cached?.key === publishableKey) return cached.loading
  const loading = loadStripe(publishableKey)
  cached = { key: publishableKey, loading }
  // A retry should call loadStripe again rather than replay a stale rejection.
  loading.catch(() => {
    if (cached?.loading === loading) cached = null
  })
  return loading
}
